
define('template!orderCompositionItemTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="order-composition-tab">\n  <div class="composition-card">\n    ';
 if (warning !== '') { ;
__p += '\n      <div class="warning">\n        <i class="mdi-alert-warning"></i>\n        <span>' +
((__t = ( warning )) == null ? '' : __t) +
'</span>\n      </div>\n    ';
 } ;
__p += '\n\n    <div class="composition-card-header">\n      <div class="title-with-preview">\n        ';
 if (advancedMode && previewImgUrl) { ;
__p += '\n          <img class="printarea-preview-thumb js-printarea-preview" src="' +
((__t = ( previewImgUrl )) == null ? '' : __t) +
'" data-link="' +
((__t = ( previewImgUrl )) == null ? '' : __t) +
'"/>\n        ';
 } ;
__p += '\n        <h3 class="title">' +
((__t = ( printAreaName )) == null ? '' : __t) +
'</h3>\n      </div>\n      ';
 if (notDesign2) { ;
__p += '\n        <div class="clickable btn-delete-print-area" printzone="' +
((__t = ( pzId )) == null ? '' : __t) +
'" title="' +
((__t = ( _.i18n('common.delete') )) == null ? '' : __t) +
'">\n          <i class="mdi-action-delete icon js-remove-icon"></i>\n        </div>\n      ';
 } ;
__p += '\n    </div>\n\n    ';
 if (exportFileUid) { ;
__p += '\n      <div class="custom-export-container">\n        <i class="mdi-file-file-download"></i>\n        <strong>' +
((__t = ( _.i18n("order.customExport") )) == null ? '' : __t) +
':</strong>\n        <a href="' +
((__t = ( customExportUrl )) == null ? '' : __t) +
'">artwork</a>\n        <i class="mdi-action-delete js-delete-custom-export clickable" data-composition-id="' +
((__t = ( secId )) == null ? '' : __t) +
'"></i>\n      </div>\n    ';
 } ;
__p += '\n\n    <div class="composition-body">\n      <div class="print-area-image-container">\n        <img class="img-responsive composition-img" src="' +
((__t = ( prinAreaImgUrl )) == null ? '' : __t) +
'"/>\n        <label class="bg-color-toggle">\n          <input type="checkbox" class="useBackgroundColor" ' +
((__t = ( useBackgroundColor ? 'checked' : '' )) == null ? '' : __t) +
'>\n          <span>' +
((__t = ( _.i18n("composition.useBackgroundColor") )) == null ? '' : __t) +
'</span>\n        </label>\n      </div>\n\n      <div class="print-area-info">\n        ';
 if (notDesign2) { ;
__p += '\n          <div class="pz-selector-wrapper">\n            <label class="pz-selector-label">' +
((__t = ( _.i18n('common.printZone') || 'Print Zone' )) == null ? '' : __t) +
'</label>\n            <select class="itName" currentPrintzone="' +
((__t = ( pzId )) == null ? '' : __t) +
'" ';
 if (selectedPzMinQtyExceeded) { ;
__p += 'style="color: red;"';
 } ;
__p += '>\n              ';
 _.each(availablePzs, function(availablePz) {
                var minQtyExceeded = advancedMode && availablePz.minimumQuantity > 1 && availablePz.minimumQuantity > orderQuantity;
              ;
__p += '\n                <option value="' +
((__t = ( availablePz.id )) == null ? '' : __t) +
'" ' +
((__t = ( availablePz.id === pzId ? 'selected' : '' )) == null ? '' : __t) +
' ';
 if (minQtyExceeded) { ;
__p += 'style="color: red;"';
 } ;
__p += '>\n                  ' +
((__t = ( availablePz.imppCode )) == null ? '' : __t) +
'\n                  ';
 if (availablePz.maxColors) { ;
__p += ' (' +
((__t = ( availablePz.maxColors )) == null ? '' : __t) +
' C)';
 } else if (availablePz.digital) { ;
__p += ' (DIG)';
 } else if (availablePz.eng) { ;
__p += ' (ENG)';
 } ;
__p += '\n                  - ' +
((__t = ( availablePz.name )) == null ? '' : __t) +
' (' +
((__t = ( availablePz.width + "x" + availablePz.height + "mm" )) == null ? '' : __t) +
')\n                  ';
 if (availablePz.printerName) { ;
__p += '(' +
((__t = ( _.i18n('printZone.printedBy') + ' ' + availablePz.printerName )) == null ? '' : __t) +
')';
 } ;
__p += '\n                  ' +
((__t = ( availablePz.productionTime )) == null ? '' : __t) +
'\n                  ';
 if (advancedMode && availablePz.minimumQuantity > 1) { ;
__p += '(Min: ' +
((__t = ( availablePz.minimumQuantity )) == null ? '' : __t) +
')';
 } ;
__p += '\n                </option>\n              ';
 }) ;
__p += '\n            </select>\n          </div>\n        ';
 } else { ;
__p += '\n          <h4 class="itName">' +
((__t = ( itName )) == null ? '' : __t) +
'</h4>\n        ';
 } ;
__p += '\n\n        ';
 if (usedColors.length !== 0) { ;
__p += '\n          <div class="colors-section">\n            <label class="colors-label">' +
((__t = ( _.i18n('common.colors') || 'Colors' )) == null ? '' : __t) +
' (' +
((__t = ( usedColors.length )) == null ? '' : __t) +
')</label>\n            <ul class="list-unstyled used-color-list">\n              ';
 _.each(usedColors, function(item) { ;
__p += '\n                <li>\n                  <div class="used-color-box" style="background-color:' +
((__t = ( item.hexaValue )) == null ? '' : __t) +
'"></div>\n                  <span>' +
((__t = ( item.name )) == null ? '' : __t) +
'</span>\n                </li>\n              ';
 }); ;
__p += '\n            </ul>\n          </div>\n        ';
 } ;
__p += '\n\n        <div class="composition-actions">\n          <a href="' +
((__t = ( compuzzProProtocol )) == null ? '' : __t) +
'://' +
((__t = ( tokenId )) == null ? '' : __t) +
'" class="btn-connect-compuzzpro action-btn" title="Connect CompuzzPro">\n            <i class="mdi-action-launch"></i>\n            <span>Connect</span>\n          </a>\n          <span class="btn-edit-compuzzpro clickable action-btn" title="Edit CompuzzPro">\n            <i class="mdi-editor-mode-edit"></i>\n            <span>Edit Compuzz Pro</span>\n          </span>\n          ';
 if (displayEditButtons) { ;
__p += '\n            ';
 if (advancedMode) { ;
__p += '\n              <span class="btn-check-stroke clickable action-btn" title="Check stroke width">\n                <i class="mdi-action-track-changes"></i>\n                <span>Stroke</span>\n              </span>\n              <span class="btn-check-stroke-pixel clickable action-btn" title="Check real stroke width in pixel image (min 0.5mm)">\n                <i class="mdi-image-photo"></i>\n                <span>Stroke Check Pixel Images</span>\n              </span>\n            ';
 } ;
__p += '\n            <span class="btn-ai-design clickable action-btn" title="' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.button', null, 'Generate a design with AI, within the limits of the printing technique') )) == null ? '' : __t) +
'">\n              <i class="mdi-image-brush"></i>\n              <span>' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.title', null, 'AI design') )) == null ? '' : __t) +
'</span>\n            </span>\n            ';
 if (editorUrl) { ;
__p += '\n              <span class="btn-edit-compuzz clickable action-btn action-btn-highlight" printZone="' +
((__t = ( printZone )) == null ? '' : __t) +
'" title="Edit Compuzz">\n                <i class="mdi-image-edit"></i>\n                <span>Editor</span>\n              </span>\n            ';
 } ;
__p += '\n          ';
 } ;
__p += '\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n';

}
return __p
};});

